import "./App.css";
import Inicio from "./pages/Inicio";
import Menu from "./components/Menu";
import Pie from "./components/Pie";
import Detalles from "./pages/Detalles";
import Busqueda from "./pages/Busqueda";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Generos from "./components/Generos";
import Accion from "./pages/content/Accion";
import Animacion from "./pages/content/Animacion";
import Aventura from "./pages/content/Aventura";
import CienciaFiccion from "./pages/content/CienciaFiccion";
import Clasicas from "./pages/content/Clasicas";
import Comedia from "./pages/content/Comedia";
import Crimen from "./pages/content/Crimen";
import Documental from "./pages/content/Documental";
import Drama from "./pages/content/Drama";
import Familia from "./pages/content/Familia";
import Fantasia from "./pages/content/Fantasia";
import Historia from "./pages/content/Historia";
import Infantil from "./pages/content/Infantil";
import Misterio from "./pages/content/Misterio";
import Musica from "./pages/content/Musica";
import Romance from "./pages/content/Romance";
import SuperHeroe from "./pages/content/SuperHeroe";
import Suspenso from "./pages/content/Suspenso";
import Terror from "./pages/content/Terror";
import SeriesDetalles from "./pages/SeriesDetalles";
import Peliculas from "./pages/Peliculas";
import Series from "./pages/Series";

function App() {
  return (
    <>
      <Router>
        <header>
          <Menu></Menu>
        </header>

        <main>
          <Generos></Generos>
          <Routes>
            <Route path="/serie/:id" element={<SeriesDetalles />}></Route>
            <Route path="/pelicula/:id" element={<Detalles />}></Route>
            <Route path="/terror/" element={<Terror />}></Route>
            <Route path="/suspenso/" element={<Suspenso />}></Route>
            <Route path="/superheroe/" element={<SuperHeroe />}></Route>
            <Route path="/romance/" element={<Romance />}></Route>
            <Route path="/musica/" element={<Musica />}></Route>
            <Route path="/misterio/" element={<Misterio />}></Route>
            <Route path="/infantil/" element={<Infantil />}></Route>
            <Route path="/historia/" element={<Historia />}></Route>
            <Route path="/fantasia/" element={<Fantasia />}></Route>
            <Route path="/familia/" element={<Familia />}></Route>
            <Route path="/drama/" element={<Drama />}></Route>
            <Route path="/documental/" element={<Documental />}></Route>
            <Route path="/comedia/" element={<Comedia />}></Route>
            <Route path="/clasicas/" element={<Clasicas />}></Route>
            <Route path="/crimen/" element={<Crimen />}></Route>
            <Route
              path="/ciencia-ficcion/"
              element={<CienciaFiccion />}
            ></Route>
            <Route path="/aventura/" element={<Aventura />}></Route>
            <Route path="/animacion/" element={<Animacion />}></Route>
            <Route path="/accion/" element={<Accion />}></Route>
            <Route path="/buscar/" element={<Busqueda />}></Route>
            <Route path="/series/" element={<Series />}></Route>
            <Route path="/peliculas/" element={<Peliculas />}></Route>
            <Route path="/" element={<Inicio />}></Route>
            <Route path="*" element={<Inicio />}></Route>
          </Routes>
        </main>

        <footer>
          <Pie></Pie>
        </footer>
      </Router>
    </>
  );
}

export default App;
